// Hide Doran review widgets when there are no reviews (v2: also handles rating iframe)
(function () {
  function pageHasNoReviews() {
    var bodyText = document.body ? document.body.textContent : '';
    return /currently no feedback or reviews available/i.test(bodyText) ||
      (/no reviews/i.test(bodyText) && /0\.0\/5/.test(bodyText));
  }

  function hideEmptyReviews() {
    // 1) Hide main-DOM widgets that show the empty state
    var widgets = document.querySelectorAll('[class*="doran"], [class*="review"], [id*="doran"], [id*="review"]');
    widgets.forEach(function (w) {
      if (w.tagName === 'IFRAME') return; // handled below
      var text = w.textContent || '';
      if (/0\.0\/5|currently no feedback/i.test(text)) {
        w.style.display = 'none';
      }
    });

    // 2) Hide Doran rating iframes (e.g. "Overview Rating" above the title)
    //    when the product has no reviews. Iframe contents are cross-origin,
    //    so we rely on the page-level empty-state signal.
    if (pageHasNoReviews()) {
      document.querySelectorAll('iframe').forEach(function (f) {
        var src = (f.getAttribute('src') || '') + ' ' + (f.getAttribute('title') || '') + ' ' + (f.getAttribute('name') || '');
        if (/doran|overview rating|product.?review/i.test(src)) {
          f.style.display = 'none';
          var wrap = f.closest('div');
          if (wrap && wrap.textContent.trim() === '') wrap.style.display = 'none';
        }
      });
      // Also hide app-block containers for the doran rating widget
      document.querySelectorAll('[id*="doran"], [class*="doran"]').forEach(function (el) {
        if (el.querySelector('iframe')) el.style.display = 'none';
      });
    }
  }

  function run() {
    hideEmptyReviews();
    setTimeout(hideEmptyReviews, 1200);
    setTimeout(hideEmptyReviews, 2500);
    setTimeout(hideEmptyReviews, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
